import { useTranslation } from '../i18n/hooks/useTranslation'
import { TranslationLanguageSelector } from './TranslationLanguageSelector'
import { TranslationLanguageMultiSelector } from './TranslationLanguageMultiSelector'

interface Language {
  code: string
  name: string
  flag: string
}

interface BulkTranslationLanguageSelectorProps {
  sourceLanguage: string
  targetLanguages: string[]
  languages: Language[]
  onSourceLanguageChange: (language: string) => void
  onTargetLanguageToggle: (languageCode: string) => void
  onSelectAllTargets: () => void
  onClearAllTargets: () => void
}

export function BulkTranslationLanguageSelector({
  sourceLanguage,
  targetLanguages,
  languages,
  onSourceLanguageChange,
  onTargetLanguageToggle,
  onSelectAllTargets,
  onClearAllTargets
}: BulkTranslationLanguageSelectorProps) {
  const { t } = useTranslation()

  const availableTargetLanguages = languages.filter(lang => lang.code !== sourceLanguage)

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Source Language */}
      <TranslationLanguageSelector
        label={t('translations.sourceLanguage')}
        value={sourceLanguage}
        onChange={onSourceLanguageChange}
        languages={languages}
      />

      {/* Target Languages */}
      <TranslationLanguageMultiSelector
        label={t('translations.targetLanguages')}
        selectedLanguages={targetLanguages}
        onToggleLanguage={onTargetLanguageToggle}
        onSelectAll={onSelectAllTargets}
        onClearAll={onClearAllTargets}
        languages={availableTargetLanguages}
        selectAllText={t('actions.selectAll')}
        clearAllText={t('actions.clearAll')}
      />
    </div>
  )
}